import {
  BIDDER_SEAT_NAME_ERROR,
  BIDDER_SEAT_NAME_REGEX,
  MARKETPLACE_BIDDER_SEAT_NAME_ERROR,
  MARKETPLACE_BIDDER_SEAT_NAME_REGEX,
  PBSTCK_BIDDER_SEAT_NAME_ERROR,
  PBSTCK_BIDDER_SEAT_NAME_REGEX,
} from '@pubstack/common/src/bidder-seat'
import { FunctionComponent } from 'react'
import { useFormContext } from 'react-hook-form'
import { Input } from '~/components/Input'

export type BidderSeatNameVariant = 'pbs' | 'pbstck-bidder' | 'marketplace'

const VARIANT_CONFIG = {
  pbs: { pattern: BIDDER_SEAT_NAME_REGEX, patternError: BIDDER_SEAT_NAME_ERROR, locked: false },
  'pbstck-bidder': { pattern: PBSTCK_BIDDER_SEAT_NAME_REGEX, patternError: PBSTCK_BIDDER_SEAT_NAME_ERROR, locked: false },
  marketplace: { pattern: MARKETPLACE_BIDDER_SEAT_NAME_REGEX, patternError: MARKETPLACE_BIDDER_SEAT_NAME_ERROR, locked: false },
} as const satisfies Record<BidderSeatNameVariant, unknown>

type Props = {
  variant: BidderSeatNameVariant
  nameError: string
  onChange: () => void
}

export const BidderSeatNameField: FunctionComponent<Props> = ({ variant, nameError, onChange }) => {
  const {
    control,
    formState: { errors },
  } = useFormContext<{ name: string }>()
  const { pattern, patternError, locked } = VARIANT_CONFIG[variant]

  const errorMessage = errors.name?.type === 'required' ? 'Seat name is required' : errors.name?.type === 'pattern' ? patternError : nameError || undefined

  return <Input error={errorMessage} rules={{ required: true, pattern }} control={control} name="name" label="Seat name" disabled={locked} onChange={onChange} />
}
